import { application } from "./application"
import EmbedCalendarController from "./embed_calendar_controller"
import EmbedIframeHeightController from "./embed_iframe_height_controller"
import EventApplicationFormController from "./event_application_form_controller"
import EventContactProfilesFormController from "./event_contact_profiles_form_controller"
import EventRowController from "./event_row_controller"
import FlashToastController from "./flash_toast_controller"
import HelloController from "./hello_controller"
import MemberChartController from "./member_chart_controller"
import ModalController from "./modal_controller"
import PasswordChangeController from "./password_change_controller"
import PopoverController from "./popover_controller"
import WithdrawalFormController from "./withdrawal_form_controller"

application.register("embed-calendar", EmbedCalendarController)
application.register("embed-iframe-height", EmbedIframeHeightController)
application.register("event-application-form", EventApplicationFormController)
application.register("event-contact-profiles-form", EventContactProfilesFormController)
application.register("event-row", EventRowController)
application.register("flash-toast", FlashToastController)
application.register("hello", HelloController)
application.register("member-chart", MemberChartController)
application.register("modal", ModalController)
application.register("password-change", PasswordChangeController)
application.register("popover", PopoverController)
application.register("withdrawal-form", WithdrawalFormController)
